import { Table, Tooltip } from "antd";
import React, { useState, useEffect } from 'react';
import 'antd/dist/antd.min.css';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import SearchBar from './SearchBar';
import { Model } from '../utilities/Model';
import usePageVisibility from '../utilities/usePageVisibility';
import useAuth from '../hooks/useAuth';
import axiosInstance from '../utilities/axiosInstance';
import { showAlert } from "./AlertPopup";

const HistoricalRecords = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isSubmitted, setIsSubmitted] = useState({});
  const [open, setOpen] = useState(false);
  const [taskid, setTaskId] = useState();
  const [searchValue, setSearchValue] = useState('');
  const [finalData, setFinalData] = useState([]);
  const { auth } = useAuth();

  const urlParams = new URLSearchParams(window.location.search);
  const projectId = urlParams.get('project_id');

  useEffect(() => {
    fetchHistoricalRecords();  // Initial data fetch
  }, []);

  usePageVisibility(() => {
    fetchHistoricalRecords();
  });

  const fetchHistoricalRecords = () => {
    axiosInstance.get(`/historicalRec`,{
      params: {
        project_id : projectId
      },
    })
      .then(res => {
        setData(res.data);
        setLoading(false);
        setFinalData(res.data);
      }).catch(error => {
        console.error(error);
      });
  };

  const refreshData = () => {
    fetchHistoricalRecords();
  };

  useEffect(() => {
    if (searchValue != '') {
      const newData = data.filter((item) => {
        return item.tagger.includes(searchValue);
      })
      setFinalData(newData);
    } else {
      setFinalData(data);
    }
  }, [searchValue])

  const columns = [
    {
      title: (
        <Tooltip title="Created Date">
          <span>Date</span>
        </Tooltip>
      ),
      dataIndex: 'createdDate',
      key: 'createdDate',
      render: (date) => new Date(date).toLocaleDateString()
    },
    {
      title: (
        <Tooltip title="Title">
          <span>Title</span>
        </Tooltip>
      ),
      dataIndex: 'task_folder_name',
      key: 'task_folder_name',
      render: (text) => (
        <Tooltip title={text}>
          <div style={{
            width: '150px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}>
            {text}
          </div>
        </Tooltip>
        )
    },
    {
      title: (
        <Tooltip title="Project Name">
          <span>Project</span>
        </Tooltip>
      ),
      dataIndex: 'project_name',
      key: 'project_name',
      render: (text) => (
        <Tooltip title={text}>
          <div style={{
            width: '150px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}>
            {text}
          </div>
        </Tooltip>
        )
    },
    {
      title: (
        <Tooltip title="Task Status">
          <span>Status</span>
        </Tooltip>
      ),
      dataIndex: 'task_status',
      key: 'task_status',
    },
    {
      title: (
        <Tooltip title="Tagger User ID">
          <span>Tagger</span>
        </Tooltip>
      ),
      dataIndex: 'tagger',
      key: 'profile_id',
      render: (text) => (
        <Tooltip title={text}>
          <div style={{
            width: '150px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}>
            {text}
          </div>
        </Tooltip>
        )
    },
    {
      title: (
        <Tooltip title="Reviewer User ID">
          <span>Reviewer</span>
        </Tooltip>
      ),
      dataIndex: 'reviewer',
      key: 'reviewer_profile_id',
      render: (text) => (
        <Tooltip title={text}>
          <div style={{
            width: '150px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}>
            {text}
          </div>
        </Tooltip>
        )
    },
    {
      title: (
        <Tooltip title="Media Type">
          <span>Media</span>
        </Tooltip>
      ),
      dataIndex: 'task_mediatype',
      key: 'task_mediatype',
    },
    {
      title: (
        <Tooltip title="Process Type">
          <span>Process</span>
        </Tooltip>
      ),
      dataIndex: 'task_process_type',
      key: 'task_process_type',
    },
    {
      title: (
        <Tooltip title="Action">
          <span>Action</span>
        </Tooltip>
      ),
      dataIndex: 'action',
      key: 'action',
      render: (text, records) => {
        let combineId = records.task_id + '_' + records.reviewer_profile_id;
        return (<button className="w-[70px] h-[30px] rounded-[22px] px-[10px] py-[5px] text-white transition-all duration-1000 bg-gradient-to-r from-[#C300A0] to-[#00B4D2] hover:from-[#00B4D2] hover:to-[#C300A0]" onClick={showModelBox} id={combineId}>Edit</button>);
      }
    }
  ];

  const showModelBox = (e) => {
    const { id } = e.target;
    setOpen(true);
    setTaskId(id);
  }
  const handleClose = () => setOpen(false);

  useEffect(() => {
    if (searchValue != '') {
      const newData = data.filter((item) => {
        return item.tagger.includes(searchValue);
      })
      setFinalData(newData);
    } else {
      setFinalData(data);
    }
  }, [searchValue])

  return (
    <div>
      <div>
        <h2 className="font-poppins font-medium text-[20px] leading-[100%] tracking-[0%] text-gray-main pb-3 border-b border-gray-d-200 dark:text-white dark:border-white mb-[20px]">Welcome {(auth.profile_name !== 'null') ? auth.profile_name : auth.profile_username} - Historical Records Page</h2>
        <div>
          <div>
            <Table className="details-view-table" columns={columns} dataSource={finalData} loading={loading} pagination={{ pageSize: 6 }} rowKey="task_id" />
          </div>
          <Model
          open={open} 
          handleClose={handleClose} 
          taskId={taskid} 
          refreshData={refreshData}
          />
        </div>
      </div>
    </div>
  );
};

export default HistoricalRecords;
